import React, { useEffect, useRef, useState } from "react";
import { useLanguage } from "../lib/language";

const useReveal = () => {
  const ref = useRef(null);
  const [shown, setShown] = useState(false);
  useEffect(() => {
    if (!ref.current || shown) return;
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            setShown(true);
            obs.disconnect();
          }
        });
      },
      { threshold: 0.18 }
    );
    obs.observe(ref.current);
    return () => obs.disconnect();
  }, [shown]);
  return [ref, shown];
};

export const ClosingMark = () => {
  const { t } = useLanguage();
  const [ref, shown] = useReveal();

  return (
    <section
      ref={ref}
      data-testid="closing-section"
      className="px-6 md:px-12 py-32 md:py-44"
      style={{ backgroundColor: "#E3DACF" }}
    >
      <div className="max-w-4xl mx-auto text-center">
        <p
          className={`font-sans text-[10px] tracking-[0.5em] uppercase text-resilie-ink/60 ${
            shown ? "fade-up" : "opacity-0"
          }`}
        >
          ⸻ RESILIÉ ⸻
        </p>
        <h2
          data-testid="closing-title"
          className={`mt-10 md:mt-14 font-serif font-light text-resilie-ink leading-[1.05] tracking-tight
                      text-4xl sm:text-5xl md:text-6xl lg:text-7xl ${
                        shown ? "fade-up delay-200" : "opacity-0"
                      }`}
        >
          {t.closing.title}
        </h2>
        <p
          data-testid="closing-sub"
          className={`mt-10 font-sans text-[11px] tracking-[0.5em] uppercase text-resilie-ink/70 ${
            shown ? "fade-up delay-400" : "opacity-0"
          }`}
        >
          {t.closing.sub}
        </p>
      </div>
    </section>
  );
};

export default ClosingMark;
